import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ChevronRight, Undo2 } from "lucide-react";

const day = (s) => (s ? new Date(s).toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit" }) : "");
const simCount = (items) => items.reduce((n, i) => n + (i.qty || 0), 0);

const ReturnState = ({ r }) => {
  if (r.return_received_at) {
    const n = simCount(r.return_items);
    return <Badge className="bg-emerald-600 hover:bg-emerald-600 text-white text-[11px]" data-testid={`dash-return-state-${r.id}`}><span>Ricevuto<span className="hidden sm:inline"> da Markoo</span> il {day(r.return_received_at)}{n ? ` · ${n} SIM` : ""}</span></Badge>;
  }
  const delivered = /deliver|consegnat/i.test(`${r.status || ""} ${r.status_raw || ""}`);
  return <Badge className={`${delivered ? "bg-sky-600 hover:bg-sky-600" : "bg-amber-500 hover:bg-amber-500 text-black"} text-[11px]`} data-testid={`dash-return-state-${r.id}`}>{delivered ? "Consegnato · in verifica da Markoo" : "In viaggio"}</Badge>;
};

const ReturnRow = ({ r }) => (
  <Link to={`/app/console-spedizioni?cerca=${encodeURIComponent(r.order_no || "")}`} className="flex flex-wrap sm:flex-nowrap items-center gap-x-3 gap-y-1 rounded-lg px-2 py-2 transition-colors hover:bg-secondary" data-testid={`dash-return-${r.id}`}>
    <Undo2 className="w-4 h-4 text-teal-500 shrink-0" />
    <span className="flex-1 min-w-[11rem] sm:min-w-0">
      <span className="block truncate text-sm font-medium" data-testid={`dash-return-content-${r.id}`}>{r.content || "Reso SIM e materiali"}</span>
      <span className="block truncate text-xs text-muted-foreground">Spedito il {day(r.created_at)}{r.carrier_name ? ` · ${r.carrier_name}` : ""}{r.tracking ? ` · ${r.tracking}` : ""}</span>
    </span>
    <span className="ml-7 sm:ml-0 shrink-0"><ReturnState r={r} /></span>
  </Link>
);

export const DealerReturns = () => {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/shipments/returns/mine").then((r) => setRows(r.data || [])).catch(() => {}); }, []);
  if (!rows.length) return null;
  return (
    <Card className="p-4 space-y-2" data-testid="dealer-returns-card">
      <div className="flex items-center justify-between">
        <h2 className="font-head text-base font-semibold">I tuoi resi</h2>
        <Link to="/app/console-spedizioni" className="inline-flex items-center text-xs text-primary hover:underline" data-testid="dash-returns-all">Le mie spedizioni<ChevronRight className="w-3.5 h-3.5" /></Link>
      </div>
      {rows.map((r) => <ReturnRow key={r.id} r={r} />)}
    </Card>
  );
};
